import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tarneaja järgi

  <span style="color:#85c1dc;">**FI:**</span>
  Toimituksen mukaan

  <span style="color:#85c1dc;">**RU:**</span>
  Cрок доставки
*/
/* @__NO_SIDE_EFFECTS__ */
const m965 = msg(
  mf`Tarneaja järgi`,
  mf`Toimituksen mukaan`,
  mf`Cрок доставки`,
)

export { m965 as 'w.saal.reasta.tarne' }